export default {
  state: {
    visibility: false
  },
  mutations: {
    INIT_SELECT_RESPONSE_AIM_DIALOG(state) {
      state.visibility = true
    },
    RESET_SELECT_RESPONSE_AIM_DIALOG(state) {
      state.visibility = false
    }
  }
}
